import React from "react";
import { useTranslation } from "react-i18next";
import { Flame } from "lucide-react";
import { ProductCard } from "./ProductCard";

export const Bestsellers = ({ products, wishlistIds, onWishlistChange }) => {
  const { t } = useTranslation();
  const best = products.filter((p) => p.bestseller).slice(0, 4);
  return (
    <section id="bestsellers" data-testid="bestsellers-section" className="relative py-24 overflow-hidden"
      style={{
        backgroundImage: "linear-gradient(rgba(9,9,11,0.85), rgba(9,9,11,0.95)), url(https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/4df04d73e243eceaf28777d690b0b1b85a34c2f8425b4c2f946bdce9649034fe.png)",
        backgroundSize: "cover", backgroundPosition: "center",
      }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex items-center gap-4 mb-6">
          <div className="bg-yellow-400 text-black p-3 brutal-shadow-black">
            <Flame className="w-6 h-6" strokeWidth={3} />
          </div>
          <div className="font-jp text-yellow-400 text-sm tracking-widest">{t("bestsellers.eyebrow")}</div>
        </div>

        <div className="flex items-end justify-between mb-12 gap-6 flex-wrap">
          <h2 className="font-heading text-5xl sm:text-7xl uppercase text-white leading-none">
            {t("bestsellers.title_1")} <span className="text-yellow-400">{t("bestsellers.title_accent")}</span><br />{t("bestsellers.title_2")}
          </h2>
          <p className="text-zinc-300 max-w-md text-lg">{t("bestsellers.subtitle")}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {best.map((p) => (
            <ProductCard key={p.id} product={p} wishlistIds={wishlistIds} onWishlistChange={onWishlistChange} />
          ))}
        </div>
      </div>
    </section>
  );
};
